// serviceWorkerRegistration.js
// Service Worker registrieren + Update-Handling

const SW_URL = '/sw.js';

export function register(callbacks = {}) {
  if (!('serviceWorker' in navigator)) {
    console.log('ℹ️ Service Worker nicht unterstützt');
    return;
  }

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(SW_URL);
      console.log('✅ Service Worker registriert:', registration.scope);

      // Beim ersten Install
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // Neuer SW wartet — Update-Prompt anzeigen
            callbacks.onUpdate?.(registration);
          }
        });
      });

    } catch (error) {
      console.error('❌ Service Worker Registrierung fehlgeschlagen:', error);
    }
  });

  // Wenn ein neuer SW activiert wurde → Seite neu laden
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(reg => reg.unregister())
      .catch(err => console.error(err));
  }
}

// Aktiven SW zum Update auffordern
export function applyUpdate(registration) {
  registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
}
